// extracted by mini-css-extract-plugin
export var chip = "_dr-0";
export var filterDropdown = "_dr-5";
export var filterItem = "_dr-6";
export var icon = "_dr-1";
export var removeButton = "_dr-3";
export var removeIcon = "_dr-4";
export var separator = "_dr-2";